import "./style.less";

export default function BpResourceEntry() {
    return {
        restrict: "E",
        scope: {
            bpe: "=",
        },
        template: require("./template.html"),
        controller: function (
            $scope,

            $rootScope
        ) {
            const bpe = $scope.bpe; // 2 way bind

            $scope.minAmount = bpe._minAmount;
            $scope.maxAmount = bpe._maxAmount;
            $scope.isPreselected = bpe._isPreselected;
            $scope.isRequired = bpe._isRequired;

            // Update amount if preselected
            if (bpe._isPreselected) bpe.amount = bpe._maxAmount;

            $rootScope.$broadcast("booking-update-broadcast");

            $scope.updateEntry = function (diff) {
                bpe.amount += diff;

                $rootScope.$broadcast("booking-update-broadcast");
            };
        },
    };
}
